import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const HelpFileViewer = () => {
  const { helpFile } = useParams();
  const navigate = useNavigate();

  // Map help file names to their paths in the public folder
  const helpFileMap = {
    'project-management': '/help/projects/project-management.html',
    'project-dashboard': '/help/projects/project-dashboard.html',
    'task-management': '/help/projects/task-management.html',
    'milestone-tracking': '/help/projects/milestone-tracking.html',
    'team-collaboration': '/help/projects/team-collaboration.html',
    'risk-management': '/help/projects/risk-management.html',
    'time-tracking': '/help/projects/time-tracking.html',
    'risk-exposure': '/help/finance/risk-exposure.html',
    'asset-management': '/help/assets/asset-management.html',
    'assignment-usage': '/help/assets/assignment-usage.html',
    'financial-valuation': '/help/assets/financial-valuation.html',
    'maintenance-operations': '/help/maintenance/maintenance-operations.html'
  };

  useEffect(() => {
    const helpPath = helpFileMap[helpFile];
    
    if (helpPath) {
      // Redirect to the HTML file in the public folder
      // Use replace to avoid adding to history
      window.location.replace(helpPath);
    } else {
      // If help file not found, redirect to main help center
      console.warn(`Help file not found: ${helpFile}`);
      if (window.opener) {
        // If opened in a new window, redirect to help center
        window.location.replace('/help');
      } else {
        navigate('/help');
      }
    }
  }, [helpFile, navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontFamily: 'Inter, sans-serif'
    }}>
      <p>Loading help file...</p>
    </div>
  );
};

export default HelpFileViewer;

